import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { flexRender } from '@tanstack/react-table';
import React from 'react';
import { Components as TableCellComponents } from './tableCell.style';
import Tooltip from '../../Tooltip';
import EditTableCell from './EditableTableCell';
const TableCell = _ref => {
  let {
    className,
    cellData,
    fit,
    row,
    rowDepth,
    table,
    onInputChange,
    getCellStyle
  } = _ref;
  const cellTextAlign = cell => {
    if ((cell === null || cell === void 0 ? void 0 : cell.column.columnDef.type) === 'number') {
      return 'right';
    }
    return 'left';
  };
  const sortCellData = data => {
    const sortedCells = data.sort((a, b) => a.column.columnDef.className === 'expander' || a.column.columnDef.className === 'selector' ? -1 : b.column.columnDef.className === 'expander' || b.column.columnDef.className === 'selector' ? 1 : 0);
    let leftPosition = 0;
    let rightPosition = 0;
    const rightPinnedItems = sortedCells.filter(cell => cell.column.getIsPinned() === 'right');
    for (let i = rightPinnedItems.length - 1; i > 0; i--) {
      rightPosition += rightPinnedItems[i].column.getSize();
    }
    sortedCells.forEach(cell => {
      if (cell.row.original.config) {
        cell.row.original.config.forEach(item => {
          if (item.key && item.key === cell.column.id) {
            cell['rowSpan'] = item.rowSpan;
            cell['colSpan'] = item.colSpan;
          }
        });
      }
      if (cell.column.getIsPinned() === 'left') {
        cell['left'] = leftPosition;
        leftPosition += cell.column.getSize();
      }
      if (cell.column.getIsPinned() === 'right') {
        cell['right'] = rightPosition;
        rightPosition = rightPosition - cell.column.getSize();
      }
      if (cell.column.columnDef.className === 'selector' || cell.column.columnDef.className === 'expander') {
        cell['width'] = '53px';
      } else if (cell.column.getIsPinned()) {
        cell['width'] = "".concat(cell.column.columnDef.size, "px");
      } else {
        cell['width'] = 'auto';
      }
    });
    return sortedCells;
  };
  const renderCell = cell => {
    if (cell.column.columnDef.meta) {
      if (cell.column.columnDef.meta.type === 'editable') {
        return _jsx(EditTableCell, {
          table: table,
          initialValue: cell.getValue(),
          row: row,
          column: cell.column,
          inputProps: typeof cell.column.columnDef.meta.inputProps === 'function' ? cell.column.columnDef.meta.inputProps(row.original, cell.column.columnDef) : cell.column.columnDef.meta.inputProps,
          onInputChange: onInputChange
        });
      } else if (cell.column.columnDef.meta.type === 'custom' || rowDepth) {
        return cell.renderValue();
      } else {
        return flexRender(cell.column.columnDef.cell || cell.row.original[cell.column.id].value, cell.getContext());
      }
    } else {
      return flexRender(cell.column.columnDef.cell || cell.row.original[cell.column.id].value, cell.getContext());
    }
  };
  return _jsx(_Fragment, {
    children: cellData && sortCellData(cellData).map((cell, key) => _jsx(React.Fragment, {
      children: (cell.column.columnDef.className === 'selector' || cell.column.columnDef.className === 'expander' || cell.renderValue() !== null || undefined) && (cell.column.columnDef.meta && cell.column.columnDef.meta.showTooltip && _jsx(Tooltip, _extends({
        fit: fit,
        content: cell.column.columnDef.meta && cell.column.columnDef.meta.type === 'custom' || rowDepth ? cell.renderValue() : flexRender(cell.column.columnDef.cell || cell.row.original[cell.column.id].value, cell.getContext()),
        width: 'auto',
        position: "top",
        appearance: "default"
      }, cell.column.columnDef.meta.tooltipProps, {
        children: _jsx(TableCellComponents.Wrapper, _extends({
          colSpan: cell.colSpan || cell.column.columnDef.colSpan,
          alignText: cell.column.columnDef.alignData || cellTextAlign(cell),
          paddingSize: rowDepth,
          stickyColumn: cell.column.columnDef.meta && cell.column.columnDef.meta.stickyColumn,
          left: cell.left,
          right: cell.column.getIsPinned() === 'right' && cellData[key + 1] && cellData[key + 1].column ? cellData[key + 1].column.getSize() : undefined,
          width: cell.column.columnDef.size,
          rowSpan: cell.rowSpan,
          className: "".concat(className, "-cell ").concat(cell.column.id),
          style: typeof getCellStyle === 'function' ? getCellStyle(cell.row, cell.column) : {}
        }, {
          children: renderCell(cell)
        }), cell.id)
      })) || _jsx(TableCellComponents.Wrapper, _extends({
        colSpan: cell.colSpan || cell.column.columnDef.colSpan,
        alignText: cell.column.columnDef.alignData || cellTextAlign(cell),
        paddingSize: rowDepth,
        stickyColumn: cell.column.columnDef.meta && cell.column.columnDef.meta.stickyColumn,
        left: cell.left,
        right: cell.right,
        width: cell.column.columnDef.size,
        rowSpan: cell.rowSpan,
        className: "".concat(className, "-cell ").concat(cell.column.id),
        style: typeof getCellStyle === 'function' ? getCellStyle(cell.row, cell.column) : {}
      }, {
        children: renderCell(cell)
      }), cell.id))
    }, cell.id))
  });
};
export default TableCell;